import { User } from '@angular/fire/auth';
import { AuthPipe } from '@angular/fire/auth-guard';
import { pipe, map, switchMap, of } from 'rxjs';

const idTokenResult = switchMap((user: User | null) =>
  user ? user.getIdTokenResult() : of(null),
);

const customClaims = pipe(
  idTokenResult,
  map((idTokenResult) => (idTokenResult ? idTokenResult.claims as Record<string, any> : {})),
);

export const hasCustomClaimRedirect: (
  claim: string | string[],
  redirect: string,
) => AuthPipe = (claim, redirect) =>
  pipe(
    customClaims,
    map((claims) =>
      Array.isArray(claim)
        ? claim.some((c) => claims.hasOwnProperty(c))
        : claims.hasOwnProperty(claim),
    ),
    map((hasClaim) => hasClaim || redirect),
  );

export const isOnboarded: (
  claim: string | string[],
  unauthorizedRedirect: string,
  onboardRedirect: string
) => AuthPipe = (claim, unauthorizedRedirect, onboardRedirect) =>
  pipe(
    switchMap((user: User | null) => {
      if (!user) {
        return of(unauthorizedRedirect);
      }
      return user.getIdTokenResult().then((idTokenResult) => {
        const claims = idTokenResult ? idTokenResult.claims : {};
        
        // Check if user has hub assigned but is not verified
        if (claims['business_hub_assigned'] && !claims['business_verified']) {
          return '/auth/pending-approval';
        }
        
        const hasClaim = Array.isArray(claim)
          ? claim.some((c) => claims.hasOwnProperty(c))
          : claims.hasOwnProperty(claim);
        return hasClaim || onboardRedirect;
      });
    })
  );